// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-value[data-v-ee66abb6] {\n  margin-bottom: 10px;\n}\n.input-value .value[data-v-ee66abb6] {\n  color: #0a2342;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 20px;\n  overflow-wrap: break-word;\n}\n.input-value .name[data-v-ee66abb6] {\n  font-size: 15px;\n  color: rgb(148, 126, 126);\n  font-weight: 500;\n  display: block;\n  margin-bottom: 2px;\n}", ""]);
// Exports
module.exports = exports;
